import {easeOutQuart} from 'modules/ease.js';

export default function () {

    return easeOutQuart;
};
